(function () {
  const initProfileCarousels = (root = document) => {
    const sections = [];

    if (root.matches && root.matches(".js-profile-carousel")) {
      sections.push(root);
    }

    if (root.querySelectorAll) {
      sections.push(...root.querySelectorAll(".js-profile-carousel"));
    }

    sections.forEach((section) => {
      const carousel = section.querySelector(".js-profile-carousel-swiper");
      const previous = section.querySelector(".js-profile-carousel-prev");
      const next = section.querySelector(".js-profile-carousel-next");
      const pagination = section.querySelector(".js-profile-carousel-pagination");
      const fixedHeight = section.dataset.fixedHeight === "true";

      if (!carousel || typeof Swiper === "undefined") return;

      if (carousel.swiper) {
        carousel.swiper.destroy(true, true);
      }

      const swiper = new Swiper(carousel, {
        slidesPerView: 1,
        spaceBetween: 24,
        autoHeight: !fixedHeight,
        speed: 500,
        rewind: true,
        watchOverflow: true,
        navigation: {
          prevEl: previous,
          nextEl: next,
        },
        pagination: {
          el: pagination,
          clickable: true,
        },
      });

      if (fixedHeight) {
        const slides = Array.from(carousel.querySelectorAll(".profile-carousel__slide"));
        let measuredWidth = 0;

        const syncFixedHeight = () => {
          carousel.style.height = "auto";
          const tallestSlide = Math.max(...slides.map((slide) => slide.scrollHeight));

          if (tallestSlide > 0) {
            carousel.style.height = `${Math.ceil(tallestSlide)}px`;
            swiper.update();
          }
        };

        requestAnimationFrame(syncFixedHeight);

        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(syncFixedHeight);
        }

        if (typeof ResizeObserver !== "undefined") {
          const resizeObserver = new ResizeObserver(([entry]) => {
            const width = Math.round(entry.contentRect.width);

            if (width === measuredWidth) return;
            measuredWidth = width;
            requestAnimationFrame(syncFixedHeight);
          });

          resizeObserver.observe(section);
        }
      }
    });
  };

  const onReady = () => {
    initProfileCarousels();

    document.addEventListener("shopify:section:load", (event) => {
      initProfileCarousels(event.target);
    });

    document.addEventListener("shopify:block:select", (event) => {
      const slide = event.target.closest(".profile-carousel__slide");
      const carousel = slide && slide.closest(".js-profile-carousel-swiper");

      if (!slide || !carousel || !carousel.swiper) return;

      const slides = Array.from(carousel.querySelectorAll(".profile-carousel__slide"));
      const slideIndex = slides.indexOf(slide);

      if (slideIndex >= 0) {
        carousel.swiper.slideTo(slideIndex);
      }
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", onReady);
  } else {
    onReady();
  }
})();
